
import React, {
    useEffect,
    useRef,
    useState
} from "react";


import "./EvaLiveConversationDrawer.css";


//========================================================
// Eva Live Conversation Drawer
//========================================================

export default function EvaLiveConversationDrawer({
    open,
    messages,
    onSend,
    connected
})
{

    //----------------------------------------------------
    // State
    //----------------------------------------------------

    const [input, setInput] =
        useState("");

    const [sending, setSending] =
        useState(false);


    //----------------------------------------------------
    // References
    //----------------------------------------------------

    const messagesEndRef =
        useRef(null);


    //====================================================
    // Scroll To Latest Message
    //====================================================

    useEffect(
        () =>
        {

            messagesEndRef.current?.scrollIntoView(
                {
                    behavior: "smooth",
                    block: "end"
                }
            );

        },
        [messages, open]
    );


    //====================================================
    // Send Message
    //====================================================

    const sendMessage =
        async () =>
        {

            const text =
                input.trim();

            if (
                !text ||
                !connected ||
                sending
            )
            {
                return;
            }

            setSending(true);

            try
            {

                await onSend(text);

                setInput("");

            }
            catch (exception)
            {

                console.error(
                    "Unable to send Fiona message:",
                    exception
                );

            }
            finally
            {

                setSending(false);

            }

        };


    //====================================================
    // Render
    //====================================================

    return (

       <div className="eva-live-chat-drawer">

            {/*============================================
              Header
            =============================================*/}

            <div
                className="eva-live-chat-header"
            >

                <div
                    className="eva-live-chat-heading"
                >
                    Fiona
                </div>

                <div
                    className="eva-live-chat-subtitle"
                >
                    Live Conversation
                </div>

            </div>


            {/*============================================
              Messages
            =============================================*/}

            <div
                className="eva-live-chat-messages"
            >

                {
                    messages.length === 0
                    &&
                    <div
                        className="eva-live-chat-empty"
                    >
                        Your conversation with Fiona
                        will appear here.
                    </div>
                }

                {
                    messages.map(
                        message =>
                        (

                            <div
                                key={message.id}
                                className={
                                    "eva-live-chat-message-row "
                                    +
                                    (
                                        message.role === "user"
                                            ? "eva-live-chat-message-row-user"
                                            : "eva-live-chat-message-row-fiona"
                                    )
                                }
                            >

                                <div
                                    className={
                                        "eva-live-chat-message "
                                        +
                                        (
                                            message.role === "user"
                                                ? "eva-live-chat-message-user"
                                                : "eva-live-chat-message-fiona"
                                        )
                                    }
                                >

                                    {message.text}

                                </div>

                            </div>

                        )
                    )
                }

                <div
                    ref={messagesEndRef}
                />

            </div>


            {/*============================================
              Input
            =============================================*/}

            <div
                className="eva-live-chat-input-area"
            >

                <div
                    className="eva-live-chat-input-shell"
                >

                    <textarea
                        value={input}
                        placeholder={
                            connected
                                ? "Ask Fiona anything..."
                                : "Start a conversation first..."
                        }
                        disabled={!connected || sending}
                        rows={1}
                        onChange={
                            event =>
                                setInput(
                                    event.target.value
                                )
                        }
                        onKeyDown={
                            event =>
                            {

                                if (
                                    event.key === "Enter" &&
                                    !event.shiftKey
                                )
                                {

                                    event.preventDefault();
                                    sendMessage();

                                }

                            }
                        }
                    />

                    <button
                        type="button"
                        className="eva-live-chat-send"
                        disabled={
                            !connected ||
                            !input.trim() ||
                            sending
                        }
                        onClick={sendMessage}
                        aria-label="Send message"
                    >
                        ➤
                    </button>

                </div>

                <div
                    className="eva-live-chat-hint"
                >
                    Press Enter to send · Shift+Enter for a new line
                </div>

            </div>

        </div>

    );

}
